import React, { useEffect, useState } from 'react';
import Footer from '../Components/footer';
import { Link, useNavigate } from "react-router-dom";
import Logo from "../Images/Home/boat.png";
import Vid from "../Images/Contact/sunset.webm";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";

export default function ContactUs(props) {
    const [User, SetUser] = useState('');

    useEffect(() => {
        onAuthStateChanged(props.auth, (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/firebase.User
                SetUser(user);
                const uid = user.uid;
                // ...
                console.log("uid", uid)
            } else {
                // User is signed out
                // ...
                console.log("user is logged out")
            }
        });
    }, [])

    function signout() {
        signOut(props.auth).then(() => {
            window.location.reload(false);
            // Sign-out successful.
        }).catch((error) => {
            // An error happened.
        });
    }
    return (
        <div>
        <nav className="navbar navbar-expand-lg navbar-dark nav-bg fixed-top">
        <div className="container-fluid">
            <a className="navbar-brand" href="#"><img src={Logo} alt="Logo" width="30" height="30" /></a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav me-auto mb-2 mb-lg-0 navbar-nav-scroll">
                    <li className="nav-item">
                        <Link to="/" className="nav-link" aria-current="page">Home</Link>
                    </li>
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            Boats
                        </a>
                        <ul className="dropdown-menu">
                            <li><Link to="/cechoii" className="dropdown-item">C-ECHO II</Link></li>
                            <li><Link to="/nimar" className="dropdown-item">Nimar</Link></li>
                        </ul>
                    </li>

                    <li className="nav-item">
                        <Link to="/routes" className="nav-link">Routes</Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/news" className="nav-link">News</Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/contactus" className="nav-link active">Contact us</Link>
                    </li>
                </ul>
                <ul className="navbar-nav navbar-nav-scroll">
                    <li className="nav-item">
                        <Link to="/login" className="nav-link">Login</Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/signup" className="nav-link">Register</Link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
            <section>
                <div className="video-wrapper">
                    <video playsInline autoPlay muted loop poster="Images2/6.jpg">
                        <source src={Vid} type="video/webm" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </section>
            <section id="Booking">
                <div className="form-body">
                    <div className="row">
                        <div className="form-holder">
                            <div className="form-content">
                                <div className="form-items">
                                    <h3>Book Now</h3>
                                    <p>Fill in the data below.</p>
                                    <form className="requires-validation" noValidate>
                                        <div className="col-md-12">
                                            <input className="form-control" type="text" name="name" placeholder="Full Name" required />
                                            <div className="valid-feedback">Username field is valid!</div>
                                            <div className="invalid-feedback">Username field not valid!</div>
                                        </div>
                                        <div className="col-md-12">
                                            <input className="form-control" type="email" name="email" placeholder="E-mail Address" required />
                                            <div className="valid-feedback">Email field is valid!</div>
                                            <div className="invalid-feedback">Email field not valid!</div>
                                        </div>
                                        <div className="col-md-12">
                                            <input className="form-control" type="text" name="tel" placeholder="Phone Number" required />
                                            <div className="invalid-feedback">Phone Numebr field not valid!</div>
                                        </div>
                                        <div className="col-md-12">
                                            <select className="form-select mt-3" required>
                                                <option selected disabled value>Boat</option>
                                                <option value="nimar">Nimar</option>
                                                <option value="cecho">C-echo II</option>
                                            </select>
                                            <div className="valid-feedback">You selected a Boat!</div>
                                            <div className="invalid-feedback">Please select a Boat!</div>
                                        </div>
                                        <div className="col-md-12">
                                            <select className="form-select mt-3" required>
                                                <option selected disabled value>Route</option>
                                                <option value="route">NORTH CLASSIC</option>
                                                <option value="route">NORTH + BROTHERS</option>
                                                <option value="route">WRECKS</option>
                                                <option value="route">GREAT SOUTH</option>
                                            </select>
                                            <div className="valid-feedback">You selected a position!</div>
                                            <div className="invalid-feedback">Please select a position!</div>
                                        </div>
                                        <div className="col-md-12 mt-3">
                                            <label className="mb-3 mr-1" htmlFor="gender">Gender: </label>
                                            <input type="radio" className="btn-check" name="gender" id="male" autoComplete="off" required />
                                            <label className="btn btn-sm btn-outline-secondary" htmlFor="male">Male</label>
                                            <input type="radio" className="btn-check" name="gender" id="female" autoComplete="off" required />
                                            <label className="btn btn-sm btn-outline-secondary" htmlFor="female">Female</label>
                                            <div className="valid-feedback mv-up">You selected a gender!</div>
                                            <div className="invalid-feedback mv-up">Please select a gender!</div>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" defaultValue id="invalidCheck" required />
                                            <label className="form-check-label">I confirm that all data are correct</label>
                                            <div className="invalid-feedback">Please confirm that the entered data are all correct!</div>
                                        </div>
                                        <div className="form-button mt-3">
                                            <button id="submit" type="submit" className="btn btn-primary">Register</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}